import { Title, Text } from "@mantine/core";

export function ReviewQueuePage() {
  return (
    <>
      <Title order={2} mb="md">
        Review Queue
      </Title>
      <Text c="dimmed">Data quality review queue for flagged price observations.</Text>
    </>
  );
}
